<template>
  <div class="chat">
    <div class="chat-zoom">
      <!-- <div class="scroll-div"> -->
      <div class="zoom-left" id="zoomLeft">
        <!-- <el-input placeholder="请输入内容" v-model="searchValue">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input> -->

        <div class="left-content" v-if="chatList.length > 0" id="leftContent">
          <div
            class="left-cell"
            v-for="(item, index) in chatList"
            @click="onChat(index, item)"
            :class="[activeIndex == index ? 'active' : '']"
            :key="index"
            :id="index"
          >
            <div style="display: flex" v-if="item && item.house">
              <img :src="item.house.houseImg" />
              <div class="cell-text" :id="index">
                <h3 :id="index">{{ handledecrypt(item.house.houseName) }}</h3>
                <el-badge
                  v-if="item.unReadMsgNum"
                  :value="item.unReadMsgNum"
                  class="item"
                ></el-badge>
                <!-- <div class="readNum" v-if="item.readNum">122</div> -->
                <!-- <span :id="index" v-if="item.ququestUser.type === 'text'" v-html="parseText(item.ququestUser.msg)"></span> -->
                <!-- <span :id="index" v-if="item.msgType === 'text'">消息</span>
                    <span :id="index" v-else-if="item.msgType === 'video'">[视频]</span>
                    <span :id="index" v-else-if="item.msgType === 'img'">[图片]</span> -->
              </div>
            </div>
            <div style="display: flex" v-else>
              <img
                :src="(item.ququestUser && item.ququestUser.headImg) || ''"
              />
              <div class="cell-text">
                <h3 :id="index">
                  {{
                    handledecrypt(item.ququestUser && item.ququestUser.nickName)
                  }}
                </h3>
                <el-badge
                  v-if="item.unReadMsgNum"
                  :value="item.unReadMsgNum"
                  class="item"
                ></el-badge>
                <!-- <span :id="index" v-if="item.ququestUser.type === 'text'" v-html="parseText(item.ququestUser.msg)"></span> -->
                <!-- <span :id="index" v-if="item.msgType === 'text'">消息</span>
                    <span :id="index" v-else-if="item.msgType === 'video'">[视频]</span>
                    <span :id="index" v-else-if="item.msgType === 'img'">[图片]</span> -->
              </div>
            </div>
            <div class="cell-time">
              <span v-if="item.lastTalkTime">{{ item.lastTalkTime }}</span>
              <span class="time-text">{{ statusList[item.status - 1] }}</span>
              <input
                v-if="item.status == 2"
                type="button"
                value="结束"
                @click.stop="closeZoom(item.chanId, index)"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->

      <div class="zoom-right" v-if="currentChatUserInfo !== null">
        <div class="right-head">
          {{
            handledecrypt(
              currentChatUserInfo.ququestUser &&
                currentChatUserInfo.ququestUser.nickName
            ) || 'asd'
          }}
        </div>
        <!-- 聊天内容 -->
        <div class="right-content">
          <JwChat
            @enter="bindEnter"
            v-model="inputMsg"
            :toolConfig="tool"
            :taleList="taleList"
            :height="'600px'"
            :config="config"
            scrollType="scroll"
          />

          <!-- 用户信息 -->
          <!-- <div class="userInfo">
           <img :src="currentChatUserInfo.contentOnlineMsgDto.sender.nickName" alt="" :onerror="defaultImg">
           <div class="userInfo-status">在线</div>
            <div class="userInfo-cell">
              <span>电话:</span>
              13652248859
            </div>
         </div> -->

          <!-- <div class="history"></div> -->
          <!-- 简短回复 -->
          <JwChat-talk
            :Talelist="talkList"
            :config="quickConfig"
            @event="bindTalk"
          />
        </div>
      </div>
      <div class="zoom-right" v-else></div>
    </div>
  </div>
</template>

<script>
// import VEmojiPicker from
import emojiParser from 'wechat-emoji-parser';
import { getToken } from '@/utils/token.js';
import * as chat from '@/api/chat.js';
import { decrypt } from '@/utils/encryp';

export default {
  name: 'chat',
  data() {
    return {
      cardShow: false,
      inputMsg: '',
      taleList: [
        {
          date: '2020/04/16 21:19:07',
          text: {
            text: "<video data-src='https://www.w3school.com.cn/i/movie.mp4' controls='controls' />",
          },
          mine: true,
          name: 'JwChat',
          img: 'https://earntest.qevoc.com/upload/file/images/dc8d44eb-4fa3-4e20-928a-4271b3cd9ef3.PNG',
        },
      ], // 聊天室数据
      tool: {
        // 'file','history'
        show: ['file'],
        callback: this.toolEvent,
      },
      config: {
        callback: this.headerEvent,
        historyConfig: {
          tip: '点击获取更多内容',
          callback: this.bindLoadHistory,
          zoomLastPage: false, // 聊天对话是否最后一页
        },
      },
      quickConfig: {
        // nav: ['简短问候', '楼盘知识'],
        nav: ['简短问候'],
        showAdd: true,
        maxlength: 200,
        showHeader: true,
        showDeleteBtn: true,
      },
      talkList: [
        '快捷回复1',
        '快捷回复2',
        '快捷回复3',
        '快捷回复4',
        '快捷回复5',
        '快捷回复6',
      ],
      yulanImgList: [], // 预览图片列表
      searchValue: '',
      // 会话列表
      sessPageSize: 1000,
      sessPageIndex: 1,
      sessLastPage: false,
      // 聊天记录
      zoomPageIndex: 1,
      zoomPageSize: 20,
      // zoomLastPage: false,
      activeIndex: -1,
      socketTask: null,
      chatList: [], // 聊天列表
      statusList: ['待人工回复', '沟通中', '已结束', '智能沟通中'],
      currentChatUserInfo: null, // 聊天室用户信息
      defaultImg: 'this.src="' + require('@/assets/logo.png') + '"', // 头像加载失败时默认图片
      // sayHaiList: [] // 发送问候语队列
      areaId: '',
      timer: null,
      isLoadHistory: false,
    };
  },
  // destroyed() {
  //   // 断开连接
  //   this.socketTask.onclose = res1 => {
  //   };
  // },
  // watch: {
  //   chatList(oldVal, newVal) {
  //     // console.log('oldVal', oldVal);
  //     console.log('newVla', newVal);
  //   },
  // },
  created() {
    this.userInfo = JSON.parse(getToken('userInfo'));
    // this.timer = setInterval(() => {
    this.getChatList();
    // }, 5000);
    this.areaId = localStorage.getItem('areaId')
      ? JSON.parse(localStorage.getItem('areaId')).areaId
      : '';
  },
  mounted() {
    // let zoomLeftHeight = document.getElementById('zoomLeft').clientHeight
    // let leftContentHeight =  document.getElementById('leftContent').offsetHeight
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    // 处理解密
    handledecrypt(str) {
      // console.log('处理解密', str);
      if (str.indexOf('==') > -1) {
        return decrypt(str);
      }
      return str;
    },
    // 建立socket链接
    async socketLink() {
      try {
        await chat.getSocketUrlApi().then((res) => {
          // console.log('建立socket链接', res);
          this.socketTask = new WebSocket(res.server);

          // 连接成功
          this.socketTask.onopen = () => {
            console.log('连接成功');
          };

          this.socketTask.onmessage = (data) => {
            var newData = JSON.parse(JSON.parse(data.data));
            console.log('监听消息：', newData);

            // readNum: 99
            console.log('找到聊天列表：', this.chatList);
            // let chatList = this.chatList;
            // this.chatList.forEach((item) => {
            //   if (this.chanId == newData.chanId && item.status == 3) {
            //     // 如果显示“已经结束”，客户端又发来了消息需要刷新聊天里列表
            //     this.getChatList();
            //   }
            // });

            // newChan -> 新会话  chanmsg -> 新消息
            if (newData.type === 'newchan') {
              // 如果已经在会话列表中就不添加
              let isOnList = this.chatList.every((item) => {
                return item.chanId != newData.chanId;
              });

              if (isOnList && this.chanId == newData.chanId) {
                this.$set(this.chatList, 0, newData.message);
              }

              // this.chatList.unshift(newData.message)
              // this.showBrowser()
            } else if (newData.type === 'chanmsg') {
              console.log('当前的chanId：', this.chanId);
              if (this.chanId == newData.chanId) {
                newData.isMe = false;
                this.screenMsg(newData);
                // 如果是当前聊天窗口，把未读消息改为已读消息
                this.updateMsgReadStatus(this.chanId);
              }
            }
          };
          this.socketTask.onclose = () => {
            this.$message.error('连接失败/已关闭');
            this.socketLink();
          };
        });
      } catch (e) {
        window.console.log('连接失败/已关闭', e);
      }
    },

    // 获取楼盘会话列表
    async getChatList(userId = '') {
      // this.chatList = [];
      try {
        // 获取楼盘会话 housId
        // console.log('userInfo', this.userInfo.houseId);
        let { houseId } = this.userInfo;
        await chat
          .getHouseChatListApi({
            pageSize: this.sessPageSize,
            pageIndex: this.sessPageIndex,
            status: '',
            houseId,
            responseUser: userId,
          })
          .then((res) => {
            this.chatList = [...res.data.dataList, ...this.chatList];
            // this.chatList = this.chatList.concat(res.data.dataList);
            // console.log('这里:',this.chatList)
          });
        // 获取主页会话 areaId
        await chat
          .getHomeChatListApi({
            areaId: this.areaId,
            pageSize: this.sessPageSize,
            pageIndex: this.sessPageIndex,
            status: '',
            houseId: '',
            responseUser: userId,
          })
          .then((res) => {
            let dataList = (res.data && res.data.dataList) || [];
            // console.log('主页会话：', dataList);
            this.chatList = [...dataList, ...this.chatList];
            // this.chatList = this.chatList.concat(dataList);
          });
        // this.chatList = res1.data.dataList

        // console.log(3333);
        console.log('获取楼盘会话列表：', this.chatList);
        if (!this.timer) {
          this.socketLink();
        }
        this.timer = setInterval(() => {
          this.chatList.forEach((item) => {
            this.getMsgReadStatus(item.chanId);
          });
        }, 5000);
      } catch (e) {
        window.console.log(e);
      }
    },

    // 进入聊天室
    onChat(index, item) {
      // let index = e.target.id
      // if(index === '') return
      this.activeIndex = index;
      // let curObj = this.chatList[index]
      if (this.currentChatUserInfo == item) return;
      // console.log('切换：');
      this.isLoadHistory = false;
      // 获取当前选中聊天列表中的用户信息
      this.currentChatUserInfo = item;
      this.chanId = item.chanId;
      // console.log('切换后的chanId', this.chanId);
      // 房子的信息
      this.houseObj = item.house;
      // 接入连接
      this.joinChanZoom(this.chanId);
    },

    // 加入聊天室
    async joinChanZoom(id) {
      try {
        await chat.joinChanApi(id, this.areaId).then(() => {
          // 数组中不包含说明是第一次进来,自动发送问候语
          // if(!this.sayHaiList.includes(this.chanId)) {
          //   this.sayHaiList.push(this.chanId)
          //   this.sendMsg('您好，很高兴为您服务，有什么能帮到您！', 'text')
          // }
          this.zoomPageIndex = 1;
          this.zoomPageSize = 20;
          this.getChanMsgData();
        });
      } catch (e) {
        window.console.log(e);
        this.$message.error(e.message);
      }
    },

    // 会话提醒
    showBrowser() {
      if (window.Notification && Notification.permission !== 'denied') {
        Notification.requestPermission(function (status) {
          if (status === 'granted')
            new Notification('新消息', {
              body: '您有一条新会话',
            });
        });
      }
    },

    parseText(val) {
      if (!val) return;
      const html = emojiParser(val)
        .replace(
          /<img src/g,
          '<img style="width:22px;height:22px;vertical-align: bottom;" src'
        )
        .replace(/\n/g, '<br/>');
      return html;
    },

    // 获取聊天记录
    async getChanMsgData() {
      try {
        // let userInfo = JSON.parse(JSON.stringify(this.currentChatUserInfo))
        let params = {
          chanId: this.chanId,
          areaId: this.areaId,
          pageSize: this.zoomPageSize,
          pageIndex: this.zoomPageIndex,
        };
        await chat
          .getChanMsgApi(params)
          .then((res) => {
            let { pageIndex, pageSize, totalCount, dataList } = res.data;
            this.zoomPageSize = pageSize;
            this.zoomPageIndex = pageIndex;
            this.config.historyConfig.zoomLastPage =
              totalCount < pageSize * pageIndex ? true : false;
            dataList = dataList.reverse();
            // console.log('获取消息记录：', dataList);
            this.changsHisImg(dataList);
            this.updateMsgReadStatus(this.chanId);
          })
          .catch((err) => {
            window.console.log(err);
            // this.$message.error('未知错误，刷新重试！');
          });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 获取未读消息数
    async getMsgReadStatus(chanId) {
      try {
        await chat
          .msgReadStatusApi({
            chanId,
          })
          .then((res) => {
            // console.log('未读消息数：', res);
            if (res.code == 200) {
              this.chatList.map((item) => {
                if (item.chanId == chanId) {
                  item.unReadMsgNum = res.data.unReadMsgNum;
                }
              });
              //
              // console.log('获取未读消息之后：', this.chatList);
            }
          });
      } catch (error) {
        console.log(error);
      }
    },

    // 更新未读消息的状态
    async updateMsgReadStatus(chanId) {
      try {
        await chat
          .updateMsgReadStatusApi({
            chanId,
          })
          .then((res) => {
            // console.log('未读消息数：', res);
            if (res.code == 200) {
              this.chatList.map((item) => {
                if (item.chanId == chanId) {
                  item.unReadMsgNum = 0;
                }
                let mobile =
                  (item.ququestUser && item.ququestUser.mobile) || '';
                let nickName =
                  (item.ququestUser && item.ququestUser.nickName) || '';
                return {
                  ...item,
                  ...{
                    ququestUser: {
                      ...item.ququestUser,
                      ...{
                        mobile:
                          mobile.indexOf('==') > -1
                            ? this.handledecrypt(mobile)
                            : mobile,
                        nickName:
                          nickName.indexOf('==') > -1
                            ? this.handledecrypt(nickName)
                            : nickName,
                      },
                    },
                  },
                };
              });
              // console.log('last', ary, this.chatList);
            }
          });
      } catch (error) {
        console.log(error);
      }
    },

    // 处理历史记录中的图片
    changsHisImg(dataList) {
      let newList = dataList.map((item) => {
        // console.log('message111', item);
        if (item.msgType == 'img') {
          // 有的message不是对象
          try {
            item.message = JSON.parse(item.message);
            this.yulanImgList.push(item.message.url);
          } catch (e) {
            item.message = { url: item.message };
            this.yulanImgList.push(item.message.url);
          }
        } else if (item.msgType == 'text' && this.isJSON(item.message)) {
          // console.log('text', item.message);
          item.message = JSON.parse(item.message).message;
        }
        return item;
      });
      if (!this.isLoadHistory) {
        this.taleList = [];
      }
      let taleList = [...newList, ...this.taleList];
      // console.log('tableList:', this.taleList);
      this.taleList = taleList.map((item) => {
        let mobile = (item.sender && item.sender.mobile) || '';
        let nickName = (item.sender && item.sender.nickName) || '';

        return {
          ...item,
          ...{
            sender: {
              ...item.sender,
              ...{
                mobile:
                  mobile.indexOf('==') > -1
                    ? this.handledecrypt(mobile)
                    : mobile,
                nickName:
                  nickName.indexOf('==') > -1
                    ? this.handledecrypt(nickName)
                    : nickName,
              },
            },
          },
        };
      });
      console.log('处理聊天列表;', this.taleList);
      this.$store.dispatch('chat/setYulanImgList', this.yulanImgList);
    },
    // 判断是否为JSON字符串
    isJSON(str) {
      if (typeof str == 'string') {
        try {
          let obj = JSON.parse(str);
          // 纯数字的 JSON.parse() 不会抛出异常
          if (typeof obj == 'number') {
            return false;
          }
          return true;
        } catch (e) {
          console.log('判断是否为JSON字符串', e);
          return false;
        }
      }
      console.log('It is not a string!');
    },

    // 确认按钮
    async bindEnter() {
      let str = this.stringFilter(this.inputMsg);
      this.sendMsg(str, 'text');
      console.log('输入的内容：', this.inputMsg);
      // this.inputMsg = '';
    },

    // 转义文字
    stringFilter(str) {
      var s = '';
      if (str.length === 0) {
        return '';
      }
      s = str.replace(/&/g, '&amp;');
      s = s.replace(/</g, '&lt;');
      s = s.replace(/>/g, '&gt;');
      s = s.replace(/ /g, '&nbsp;');
      return s;
    },

    // 选择工具栏的某一项
    async toolEvent(val, file) {
      try {
        // 图片上传
        // if (val === 'file') {
        //   let oFd = new FormData();
        //   file.FileList.forEach(async (item) => {
        //     oFd.append('file', item);
        //     await chat.uploadImgApi(oFd).then((res) => {
        //       // app展示是个对象
        //       this.sendMsg(JSON.stringify({ url: res.data }), 'img');
        //     });
        //   });
        // }

        if (val === 'file') {
          // console.log('上传的文件：', file[0]);
          // console.log(this.isVideo(file[0].type));

          if (this.isImage(file[0].type)) {
            let imgFile = new FormData();
            imgFile.append('file', file[0]);
            await chat.uploadImgApi(imgFile).then((res) => {
              // app展示是个对象
              this.sendMsg(JSON.stringify({ url: res.data }), 'img');
            });
            // return this.$message.warning('只能上传图片或视频文件');
          } else if (this.isVideo(file[0].type)) {
            let videoFile = new FormData();
            videoFile.append('video', file[0]);
            await chat.uploadVideoApi(videoFile).then((res) => {
              console.log(res.data.absoluteFileUrl);
              // app展示是个对象
              //  "text": { "text": "<video data-src='https://www.w3school.com.cn/i/movie.mp4' controls='controls' />" },
              // let videoStr = `<video data-src='https://www.w3school.com.cn/i/movie.mp4' controls='controls' />`;
              this.sendMsg(
                JSON.stringify({
                  url: "<video data-src='https://www.w3school.com.cn/i/movie.mp4' controls='controls' />",
                }),
                'video'
              );
              // this.sendMsg(videoStr, 'img');
            });
          } else {
            return this.$message.warning('只能上传图片或视频文件');
          }
        }
      } catch (e) {
        window.console.log(e);
      }
    },

    // 验证图片格式
    isImage(str) {
      // var reg = /\.(png|jpg|gif|jpeg|webp)$/;
      var reg = /^(\s|\S)+(jpg|png|jpeg|gif|webp|JPG|PNG|JPEG|GIF|WEBP)+$/;
      return reg.test(str);
    },
    isVideo(str) {
      var reg = /^(\s|\S)+(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)+$/;
      return reg.test(str);
    },

    // 发送信息
    async sendMsg(content, msgType) {
      try {
        let data = {
          msgType,
          type: 'chanmsg',
          chanId: this.chanId,
          sender: {
            userId: this.userInfo.userId,
            nickName: this.userInfo.nickName,
            headImg: this.userInfo.headImg,
          },
          isMe: true,
          message: content.replace(/&nbsp;/g, ' '),
          sendTime: this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        };
        console.log('发送消息：', data.message);
        let res = await chat.sentMsgApi(JSON.stringify(data));
        if (res.code === 200) {
          // this.$message.success('消息发送成功')
          this.screenMsg(data);
          this.inputMsg = '';
          // console.log('输入的内容：', this.inputMsg);
        }
      } catch (e) {
        window.console.log(e);
      }
    },

    // 接受消息(筛选处理)
    screenMsg(msg) {
      // 手机震动
      switch (msg.msgType) {
        case 'text':
          this.addTextMsg(msg);
          break;
        case 'video':
          this.addVideoMsg(msg);
          break;
        case 'voice':
          this.addVoiceMsg(msg);
          break;
        case 'img':
          this.addImgMsg(msg);
          break;
      }
    },

    // 处理文字消息
    addTextMsg(msg) {
      let obj = msg;
      if (msg && Object.keys(msg)) {
        obj = {
          ...msg,
          sender: {
            ...msg.sender,
            nickName:
              msg.sender && msg.sender.nickName
                ? this.handledecrypt(msg.sender.nickName)
                : '',
          },
        };

        // let sender = {
        //   nickName: this.handledecrypt(msg?.sender?.nickName),
        // };
        // Object.assign(obj, sender);
      }
      this.taleList.push(obj);
      console.log('发送的消息：', obj);
    },

    // 处理视频消息
    addVideoMsg(msg) {
      console.log(msg);
      // this.taleList.push(msg);
      // this.taleList.push({
      //   date: '2020/04/16 21:19:07',
      //   text: {
      //     text: 'https://www.w3school.com.cn/i/movie.mp4',
      //   },
      //   mine: true,
      //   name: 'JwChat',
      //   img: 'https://earntest.qevoc.com/upload/file/images/dc8d44eb-4fa3-4e20-928a-4271b3cd9ef3.PNG',
      // });

      this.taleList.push({
        msgType: 'video',
        type: 'chanmsg',
        chanId: '10106492-1bb7-47ad-8e61-f00795aa87f3',
        sender: {
          userId: '17F5D0AA-C70E-40A2-B672-D246FA7DD4A9',
          nickName: 'Admin',
          headImg:
            'https://ezs.evoc.cn/Upload/file/images/default_user_headimg.png',
        },
        isMe: true,
        message: {
          text: {
            text: "<video data-src='https://www.w3school.com.cn/i/movie.mp4' controls='controls' />",
          },
        },
        sendTime: '2022-08-01 08:57:35',
      });
    },

    // 处理图片消息
    addImgMsg(msg) {
      console.log('处理图片消息', msg);
      msg.message = JSON.parse(msg.message);
      // 添加到预览图片的队列中
      this.yulanImgList.push(msg.message.url);
      this.$store.dispatch('chat/setYulanImgList', this.yulanImgList);
      this.taleList.push(msg);

      // console.log('消息列表：', this.taleList);
    },

    // 关闭房间
    async closeZoom(id, index) {
      try {
        // let data = "chanId=" + id
        await chat.offChanApi(id).then((res) => {
          if (res.code !== 200) return;
          this.$message.success('结束成功！');
          this.chatList[index].status = 3;
        });
      } catch (e) {
        window.console.log(e);
      }
    },

    // 加载更多
    bindLoadHistory() {
      this.zoomPageIndex++;
      if (this.config.historyConfig.zoomLastPage)
        return this.$message.error('没有更多数据了');
      this.isLoadHistory = true;
      this.getChanMsgData();
    },

    // 简短问候
    bindTalk(val) {
      switch (val.key) {
        case 'select':
          this.inputMsg = val.value;
          break;
        case 'addTalk':
          this.talkList.push(val.value);
          break;
        case 'delIndex':
          this.talkList.splice(val.value, 1);
          break;
        default:
          break;
      }
    },

    headerEvent(type) {
      window.console.log(type);
    },

    rightClick(val) {
      window.console.log(val);
    },
  },
};
</script>

<style lang="less" scoped>
.chat {
  width: 100%;
  height: 88vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(to bottom right, #7a88ff, #7affaf);

  .chat-zoom {
    // width: 850px;
    height: 650px;
    background-color: #fff;
    display: flex;
  }
}

.zoom-left {
  width: 270px;
  height: 100%;
  background-color: #e6e5e5;
  display: flex;
  flex-direction: column;
  // overflow: auto;
  overflow-y: auto;

  .left-cell {
    width: 100%;
    height: 65px;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 6px;

    &:hover {
      background-color: #dbdada;
    }

    img {
      width: 30px;
      height: 30px;
      margin: 0 10px 0 15px;
    }

    .cell-time {
      font-size: 13px;
      color: #b4b4b4;
      position: absolute;
      top: 0px;
      right: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      span {
        display: block;
      }

      .time-text {
        color: #ffaa00;
      }

      .time-btn {
        display: inline-block;
        border: 1px solid #ccc;
        padding: 3px;
        background-color: #fff;
        border-radius: 3px;
      }
    }
  }
}

.active {
  // &:hover
  background-color: #a5a5a5;
}

.cell-text {
  width: 80%;

  span,
  h3 {
    display: block;
    width: 100%;
    font-size: 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  span {
    font-size: 12px;
    color: #9a9a9a;
  }
  .readNum {
    // min-width: 4px;
    width: 18px;
    max-width: 42px;
    height: 14px;
    line-height: 14px;
    display: inline-block;
    border-radius: 20%;
    padding: 0 12px;
    background-color: red;
    color: #fff;
    text-align: center;
  }
}

.left-content,
.right-content {
  flex: 1;
  overflow-y: auto;

  // 滚动条样式
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.2);
  }
  &::-webkit-scrollbar-button {
    display: none;
  }

  &::-webkit-scrollbar-track {
    display: none;
    background: rgba(0, 0, 0, 0.1);
  }
}

.left-content {
  height: 670px;
}

.zoom-right {
  flex: 1;
  min-width: 600px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .right-head {
    line-height: 50px;
    font-size: 18px;
    background-color: #409eff;
    color: #fff;
    // border-bottom: 1px solid #ddd;
    text-indent: 30px;
  }
  .right-content {
    display: flex;
  }
}

/deep/ .web__main-text {
  margin-top: 0;
}

/deep/ .web__main-user cite {
  top: -20px;
}

.userInfo {
  width: 180px;
  height: 100%;
  background-color: #f5f9fd;
  text-align: center;

  img {
    width: 70px;
    height: 70px;
    margin: 50px auto 10px;
  }

  .userInfo-status {
    font-size: 16px;
    color: #868686;
  }

  .userInfo-cell {
    margin-top: 20px;

    span {
      color: #868686;
    }
  }
}
</style>

<style lang="less">
.wrapper {
  ul:nth-child(2) {
    li {
      .el-col:nth-child(1) {
        > p {
          word-wrap: break-word;
          word-break: break-all;
          white-space: normal;
        }
      }
    }
  }
}
</style>
